// Vendor
import $ from 'jquery';

// Modules
import FontAwesome from './modules/font-awesome';
import VideoModal from './modules/video-modal';
import MobileNav from './modules/mobile-nav';
import Sidebar from './modules/sidebar';

$(document).ready(() => {
    const fontAwesome = new FontAwesome();
    fontAwesome.init();

    const mobileNav = new MobileNav();
    mobileNav.init();

    if ($('.video-play-button.-modal').length) {
        const videoModal = new VideoModal();
        videoModal.init();
    }

    if ($('.sidebar').length) {
        const sidebar = new Sidebar();
        sidebar.init();
    }

    // Misc minor functions that don't demand their own class

    // On staff list page, toggle show more / less bio on click
    $('.toggle-text').on('click', (e) => {
        e.preventDefault();
        const $target = e.target;

        $($target).prev().toggleClass('show');
    });
});
